import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEOMeta from '../components/SEOMeta';

function ReturnsPage() {
  return (
    <div className="about-page">
      <SEOMeta
        title="Returns and Warranty"
        description="Hercles Global returns and warranty information. Learn how returns work, what is eligible, and how to contact support in Kenya."
        canonical="/returns"
      />
      <Header />
      <main className="about-inner">
        <section className="about-hero">
          <h1>Returns and Warranty</h1>
          <p>We support eligible returns and warranty claims so you can shop with confidence.</p>
        </section>

        <section className="about-section">
          <h2>Return Window</h2>
          <p>Products may be returned within 30 days when they are unused, complete, and in original packaging. Please contact us before returning an item.</p>
        </section>

        <section className="about-section">
          <h2>Warranty Support</h2>
          <ul>
            <li>Eligible products include manufacturer warranty where applicable</li>
            <li>Defective items should be reported as soon as possible</li>
            <li>Warranty handling depends on the product condition and supplier terms</li>
          </ul>
        </section>

        <section className="about-section">
          <h2>Start A Return</h2>
          <p>Call or WhatsApp <a href="tel:+254724474097">+254 724 474097</a>, or email <a href="mailto:info@herclesglobal.com">info@herclesglobal.com</a> with your order details.</p>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default ReturnsPage;
